import FttsLandingPage from './FttsLandingPage';
export default FttsLandingPage;
